const header = {
  "header.menu_01": "Beranda",
  "header.menu_02": "Jelajahi Define®",
    "header.list_menu_01": "Katalog",
    "header.list_menu_02": "Define® Classic",
    "header.list_menu_03": "Define® Fresh",
  "header.menu_03": "Cermin Virtual",
  "header.store_locator": "Cari Lokasi Toko",
  "header.menu_04": "Belanja Sekarang",
  "header.store_01": "Lazada",
  "header.store_02": "Qoo10",
  "header.store_03": "Shopee",
  "shopee_link":"https://shopee.co.id/acuvueid"
}

export default header
